import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ap32ulhtcg: FaireBrandEntity = {
  token: "b_ap32ulhtcg",
  type: "brand",
  name: "Match Candle Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/ff0b5995d9090bd33e8916391f5e3525fff470da07304679f3eb3c81f6891c9c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5d5dbf71c31cf2605bb6b7167ee1e58be300ea8129e7a8c1c3c17130a3cd3a8c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ff0b5995d9090bd33e8916391f5e3525fff470da07304679f3eb3c81f6891c9c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5d5dbf71c31cf2605bb6b7167ee1e58be300ea8129e7a8c1c3c17130a3cd3a8c.jpeg",
  location: "Swift Current, SK, CAN",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 7,
  isInsider: false,
  description:
    "Match Candle Co started in 2018 in my home in Swift Current. Over time, I've grown and moved into a commercial space where I continue to grow my product line. \nOur products are made with 100% soy wax and pure fragrance oils. Match Candle Co was named for my 5 kids first letter of their first names - Mason, Amelia, Tyler, Cody, Hayden.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:18.737Z",
    importedBy: "entity-db-cli",
  },
};
